import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import b64toBlob from 'b64-to-blob';
import { listType } from 'src/app/core/enumerations/enum-ListType';
import { downloadfile } from 'src/app/core/models/UtilModel/downloadfile.model';
import { PaginationModel } from 'src/app/core/models/pagination-model';
import { payRequestModel } from 'src/app/core/models/payRequestModel';
import { PublicPortalService } from 'src/app/core/services/public-portal/public-portal.service';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-contracts-detail',
  templateUrl: './contracts-detail.component.html',
  styleUrls: ['./contracts-detail.component.scss']
})
export class ContractsDetailComponent implements OnInit {

  payRequestModel:payRequestModel;
  paginationModel: PaginationModel;
  downloadFile: downloadfile;
  loggedInUser : any;
  selectedSort:any;
  Records:any;
  totalRecords:any;
  totalPages:number;
  pages= new Array();
  PageNo:number;
  ID:number=0;
  Organization:any;
  PN:number;
  WorthRecord = [
    { id: -2, name: 'Worth More Than 50 Million' },
    { id: -1, name: 'Worth Less Than 50 Million' }
  ];
  selectedValueWorth: any;
  isSelected: boolean;
  PCNValue: any;
  BOIRecords: any;
  constructor(
    private service:PublicPortalService,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.paginationModel = new PaginationModel();
    this.payRequestModel=new payRequestModel();
    this.downloadFile = new downloadfile();
    this.PageNo=Number(this.paginationModel.pageNumber);
    this.route.params.subscribe(params => {
      // Extract the ID from the route parameters
      const id = params['id'];
      // Store the ID in another variable
      this.ID = id;
    });
    this.GetPayDetailList();
  }

  getBOI(BOIID:any){
    this.payRequestModel.Type = listType.BOI;
    this.payRequestModel.ID = BOIID;
    this.payRequestModel.pagination = this.paginationModel;
    this.payRequestModel.pagination.pageSize="10"
    this.service.GetPayDetailList(this.payRequestModel)
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {
              let data = (baseResponse.data as any) ;
              this.BOIRecords =data?.records;
            }
          }
        }
      })
  }

  getAttachmentByGUID(Guid:any) {

    let downloadFile: any = {};

    downloadFile.ID = Guid;


    this.service.FileByGuid(downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = baseResponse.data['bytes'];
        var ContentType = baseResponse.data['contentType'];
        var FileName = baseResponse.data['fileName'];

        const blob = b64toBlob(Bytes, ContentType);
        saveAs(blob, FileName);
      }
    });
  }
  onSelectValueSearch(){
    this.Records=[]
    this.paginationModel = new PaginationModel();
    this.PageNo=Number(this.paginationModel.pageNumber)
    this.onSelectedValue()
  }
  onSelectedValue() {
      this.payRequestModel.Type = listType.Contracts;
      this.payRequestModel.ID = this.ID;
      this.payRequestModel.City=null
      this.payRequestModel.TenderNumber =this.PCNValue || null;
      this.payRequestModel.TenderWorth = this.selectedValueWorth || null;
      this.payRequestModel.Sector=null
      this.payRequestModel.Organization = null
      this.payRequestModel.Date = null
      this.payRequestModel.pagination = this.paginationModel;
      this.payRequestModel.pagination.pageSize = "10"
      this.service.GetPayDetailList(this.payRequestModel)
        .subscribe(baseResponse => {
          if (baseResponse != null) {
            if (baseResponse.success != null) {
              if (baseResponse.success) {
                this.isSelected = true;
                let data = (baseResponse.data as any);
                this.Records = data?.records
                this.totalPages = data?.totalPages;
                this.totalRecords = data?.totalRecords;
                this.totalPages = data?.totalPages;
                this.pages = new Array();
                for (let i = 1; i <= this.totalPages; i++) {
                  this.pages.push(i);
                }
              }
            }
          }
        }
        )
  }

  GetPayDetailList(){

    this.payRequestModel.Type = listType.Contracts;
    this.payRequestModel.ID = this.ID;
    this.payRequestModel.pagination = this.paginationModel;
    this.payRequestModel.pagination.pageSize="10"
    this.service.GetPayDetailList(this.payRequestModel)
      .subscribe(baseResponse => {
        if (baseResponse != null) {
          if (baseResponse.success != null) {
            if (baseResponse.success) {

                  let data = (baseResponse.data as any) ;
                  this.totalPages = data?.totalPages;
                  this.totalRecords = data?.totalRecords;
                  this.pages = new Array();
                  for (let i = 1; i <= this.totalPages; i++) {
                    this.pages.push(i);
                  }

                  this.Records =data?.records;
                  this.Organization=data?.records[0].CategoryName;
            }
          }
        }
      })
  }
  clear(){
    location.reload()
  }
  changePage(pageNumber){

    this.paginationModel.pageNumber = pageNumber;
    this.PageNo=Number(pageNumber);
    this.GetPayDetailList();
  }

  nextPage() {
    if (Number(this.paginationModel.pageNumber) < this.totalPages) {
        this.changePage(Number(this.paginationModel.pageNumber) + 1);
      }
  }

  previousPage() {
    if (Number(this.paginationModel.pageNumber) > 1) {
      this.changePage(Number(this.paginationModel.pageNumber) - 1);
    }
  }

  selectedPage()
  {
    if(this.PN==null || this.PN==0){
      this.PN=1
    }
    this.paginationModel.pageNumber =String(this.PN);
    this.PageNo=this.PN;
    this.GetPayDetailList();
  }

  onEnterKeyPressed(event: KeyboardEvent): void {
    // Check if the key pressed is Enter

    if (event.key === 'Enter') {
      // Call your function here
      this.selectedPage()
    }
  }
  getAttachmentByID(Id: any,Guid:any) {
    if(Id == 0 || Id==null){
      return;
    }
    this.downloadFile.ID = Id;
    this.downloadFile.idsList = Guid;

    this.service.DownloadFileByGuid(this.downloadFile).subscribe(baseResponse => {
      if (baseResponse.success && baseResponse.data != null) {
        var Bytes = baseResponse.data['bytes'];
        var ContentType = baseResponse.data['contentType'];
        var FileName = baseResponse.data['fileName'];

        const blob = b64toBlob(Bytes, ContentType);
        saveAs(blob, FileName);
      }
    });
  }
  sort(orderByColumnName, orderBy){
    this.paginationModel.orderBy = orderBy;
    this.payRequestModel.pagination.orderByColumnName = orderByColumnName;
    this.paginationModel.orderByColumnName = orderByColumnName
    this.GetPayDetailList();
  }
}
